import {
    Body,
    ModalContent,
    PrimaryButton,
    ResponsiveSidebarDialog,
    SecondaryButton,
    StickyModalActions,
} from '@/styles/blocks';
import { Grid } from '@material-ui/core';
import { Body1 } from '../blocks';
import { css } from '@emotion/react';

const DisclaimerModal = ({ order, disclaimers, callbacks }) => {
    const confirm = () => {
        callbacks.submitOrder(order);
        callbacks.setDisclaimer({});
    };

    const cancel = () => {
        callbacks.setDisclaimer({});
    };

    return (
        <ResponsiveSidebarDialog maxWidth="lg" open={!!order} onClose={cancel}>
            <ModalContent
                css={css`
                    min-width: 700px;
                `}
            >
                <Grid
                    direction="column"
                    css={css`
                        flex-wrap: nowrap;
                    `}
                >
                    {(disclaimers || []).map((disclaimer, idx) => (
                        <Grid
                            item
                            css={css`
                                ${idx > 0 ? 'margin-top: 24px;' : ''}
                            `}
                        >
                            <Body>{disclaimer}</Body>
                        </Grid>
                    ))}
                </Grid>
            </ModalContent>
            <StickyModalActions>
                <SecondaryButton onClick={cancel}>Cancel</SecondaryButton>
                <PrimaryButton onClick={confirm}>Acknowledge</PrimaryButton>
            </StickyModalActions>
        </ResponsiveSidebarDialog>
    );
};

export default DisclaimerModal;
